import { oz } from '@weft/utils';
import { CurrencySchema, CustomerSourcesSchema, PeriodSchema } from '../../../primitives';
import { ContractSchema } from '../../contract';
import { PricingSchema } from '../../pricing';
import { RevisionedLineItemTypeSchema } from '../../revisioned-line-item';
import { YearlyRevenueSchema } from './yearly-revenue-schema';

export const CustomerRevenueReportItemSchema = oz.object({
  customer: oz.object({
    id: oz.string(),
    name: oz.string(),
    currency: CurrencySchema,
    source: CustomerSourcesSchema.optional(),
  }),
  contract: ContractSchema.pick({
    id: true,
    startDate: true,
    endDate: true,
  }).optional(),
  productVariant: oz.object({
    id: oz.string(),
    name: oz.string(),
    pricing: PricingSchema,
  }).optional(),
  revisionedLineItem: oz.object({
    price: oz.number(),
    type: RevisionedLineItemTypeSchema,
    name: oz.string(),
  }).optional(),
  invoices: oz.array(oz.object({
    id: oz.string(),
    period: PeriodSchema,
    amount: oz.number().optional(),
    yearlyRevenue: YearlyRevenueSchema.optional(),
  })).optional(),
  invoiceId: oz.string().optional(),
  yearlyRevenue: YearlyRevenueSchema,
});

export type CustomerRevenueReportItem = oz.infer<typeof CustomerRevenueReportItemSchema>;